import { css } from "styled-components";
import getBorderRadius from "../getBorderRadius";
import getColor from "../getColor";
import space from "../space";
var getInvertedBorderRadius = function getInvertedBorderRadius(radius, color, side) {
  return css(function (_ref) {
    var theme = _ref.theme;
    var themeBorderRadius = getBorderRadius(theme, radius);
    var themeColor = getColor(theme, color);
    return css(["border-inline:", " solid ", ";border-radius:calc(2 * ", ") calc(2 * ", ") 0 0 / ", ";mask:radial-gradient( ", " at ", " 0,#0000 98%,#000 101% ) calc(-1 * ", ") 100%/100% ", " repeat-x,conic-gradient(#000 0deg,#fff 0deg) padding-box;", " ", ""], space(2), themeColor, themeBorderRadius, themeBorderRadius, themeBorderRadius, themeBorderRadius, themeBorderRadius, themeBorderRadius, themeBorderRadius, side === "right" ? css(["border-left-width:0;border-top-left-radius:0;"]) : null, side === "left" ? css(["border-right-width:0;border-top-right-radius:0;"]) : null);
  });
};
export default getInvertedBorderRadius;